/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetManagementAndControlPlanResponse } from '../models/get-management-and-control-plan-response';
import { GetFormRequest } from '../models/get-form-request';
import { CreateManagementAndControlPlanRequest } from '../models/create-management-and-control-plan-request';
import { UpdateManagementAndControlPlanRequest } from '../models/update-management-and-control-plan-request';
import { UpdateManagementAndControlPlan2Request } from '../models/update-management-and-control-plan-2request';
@Injectable({
  providedIn: 'root',
})
class ManagementAndControlPlanService extends __BaseService {
  static readonly ManagementAndControlPlanGetAllPath = '/ManagementAndControlPlan/GetAll';
  static readonly ManagementAndControlPlanGetByIdPath = '/ManagementAndControlPlan/GetById';
  static readonly ManagementAndControlPlanCreatePath = '/ManagementAndControlPlan/Create';
  static readonly ManagementAndControlPlanUpdatePath = '/ManagementAndControlPlan/Update';
  static readonly ManagementAndControlPlanUpdateRangePath = '/ManagementAndControlPlan/UpdateRange';
  static readonly ManagementAndControlPlanUploadFilePath = '/ManagementAndControlPlan/UploadFile';
  static readonly ManagementAndControlPlanDeletePath = '/ManagementAndControlPlan/Delete';
  static readonly ManagementAndControlPlanDeleteRangePath = '/ManagementAndControlPlan/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ManagementAndControlPlanGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetManagementAndControlPlanResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ManagementAndControlPlan/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetManagementAndControlPlanResponse>>;
      })
    );
  }  ManagementAndControlPlanGetAll(): __Observable<Array<GetManagementAndControlPlanResponse>> {
    return this.ManagementAndControlPlanGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetManagementAndControlPlanResponse>)
    );
  }

  /**
   * @param request undefined
   */
  ManagementAndControlPlanGetByIdResponse(request: GetFormRequest): __Observable<__StrictHttpResponse<GetManagementAndControlPlanResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ManagementAndControlPlan/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetManagementAndControlPlanResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ManagementAndControlPlanGetById(request: GetFormRequest): __Observable<GetManagementAndControlPlanResponse> {
    return this.ManagementAndControlPlanGetByIdResponse(request).pipe(
      __map(_r => _r.body as GetManagementAndControlPlanResponse)
    );
  }

  /**
   * @param request undefined
   */
  ManagementAndControlPlanCreateResponse(request: CreateManagementAndControlPlanRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ManagementAndControlPlan/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ManagementAndControlPlanCreate(request: CreateManagementAndControlPlanRequest): __Observable<string> {
    return this.ManagementAndControlPlanCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  ManagementAndControlPlanUpdateResponse(request: UpdateManagementAndControlPlanRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/ManagementAndControlPlan/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ManagementAndControlPlanUpdate(request: UpdateManagementAndControlPlanRequest): __Observable<Blob> {
    return this.ManagementAndControlPlanUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ManagementAndControlPlanUpdateRangeResponse(request: Array<UpdateManagementAndControlPlan2Request>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/ManagementAndControlPlan/UpdateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ManagementAndControlPlanUpdateRange(request: Array<UpdateManagementAndControlPlan2Request>): __Observable<Blob> {
    return this.ManagementAndControlPlanUpdateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `ManagementAndControlPlanService.ManagementAndControlPlanUploadFileParams` containing the following parameters:
   *
   * - `fileType`:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  ManagementAndControlPlanUploadFileResponse(params: ManagementAndControlPlanService.ManagementAndControlPlanUploadFileParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.fileType != null) __params = __params.set('fileType', params.fileType.toString());
    if (params.FormId != null) { __formData.append('FormId', params.FormId as string | Blob);}
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ManagementAndControlPlan/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `ManagementAndControlPlanService.ManagementAndControlPlanUploadFileParams` containing the following parameters:
   *
   * - `fileType`:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  ManagementAndControlPlanUploadFile(params: ManagementAndControlPlanService.ManagementAndControlPlanUploadFileParams): __Observable<Blob> {
    return this.ManagementAndControlPlanUploadFileResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  ManagementAndControlPlanDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/ManagementAndControlPlan/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  ManagementAndControlPlanDelete(id?: string): __Observable<Blob> {
    return this.ManagementAndControlPlanDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  ManagementAndControlPlanDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/ManagementAndControlPlan/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  ManagementAndControlPlanDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.ManagementAndControlPlanDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ManagementAndControlPlanService {

  /**
   * Parameters for ManagementAndControlPlanUploadFile
   */
  export interface ManagementAndControlPlanUploadFileParams {
    fileType?: 0 | 1 | 2 | 3 | 4 | 5;
    FormId?: string;
    File?: null | Blob;
    DirectoryPath?: null | string;
  }
}

export { ManagementAndControlPlanService }
